import _ from 'lodash';

function RecordMovementCtrl($rootScope, $scope, $stateParams, $timeout, $sce, toastr, AuthService, AnalysisService, PlanService) {
  'ngInject';

  $rootScope.$emit('base:sidebarEvent', true, true);

  // if ($stateParams.date) {
  //   $scope.$parent.base.commonData.date = $stateParams.date;
  // }

  // // ViewModel
  // const vm = this;


  // //현재 page명 세팅
  // $scope.$parent.base.pageStatus = 'teamRecordMovement';

  // //동작기록 사용자 설정창 활성화 여부 확인
  // $scope.movementsSetting = false;

  // /**
  //  * API 호출 시 parameter 로 사용할 변수
  //  */
  // vm.setResultData = $scope.$parent.base.movementResultData;
  // vm.setResultData.user_id = null;  //팀화면에서는 선수를 선택하고 해당 선수의 user_id를 입력한다. 접속자 user_id는 필요가 없음
  // vm.setResultData.movement_id = null;

  // //동작기록 기본 버튼 텍스트
  // vm.attackBtn = null;
  // vm.defenseBtn = null;
  // vm.leftFootBtn = null;
  // vm.rightFootBtn = null;


  // let userInfo = vm.appContext.userInfo;
  // console.log('userInfo : ', userInfo);
  // let userBasicInfo = {
  //   login_id: userInfo.login_id,
  //   uuid: userInfo.uuid
  // }

  // vm.userInfo = userInfo;

  // vm.metaData = {
  //   movements: null,
  //   locations: null
  // };

  // //추가 동작정보
  // vm.addMovement = {
  //   name: null
  // };

  // //삭제 동작정보
  // vm.removeMovement = {};

  // vm.movementRecord = {
  //   movemnetsText: null,
  //   skills: {
  //     movement: null,
  //     foot: null,
  //     skill: null
  //   },
  //   locations: null
  // }

  // // 훈련 정보 입력에 필요한 데이터 조회
  // // PlanService.getTrainingMeta().then(function(data) {
  // //   $scope.$apply(function() {
  // //     // movements 에서 공격,수비 삭제
  // //     _.remove(data.movements, function (movement) {
  // //       return movement.name === '공격' || movement.name === '수비';
  // //     });
  // //     console.log('getTrainingMeta : ', data);
  // //     vm.metaData.movements = data.movements;
  // //   });
  // // });

  // if(!vm.setResultData.game_id && !vm.setResultData.training_id){
  //   toastr.error('선택하신 일자에 기록된 정보가 없습니다. 먼저 해당일자를 선택하시거나 경기를 시작해주십시오');
  // }
  // //각 팀별 custom 동작 정보 가져오기
  // vm.setMovementsInfo = function(){
  //   let movementsParams = {
  //     login_id: userBasicInfo.login_id,
  //     user_id: userInfo.user_id,
  //     game_id: vm.setResultData.game_id,
  //     training_id: vm.setResultData.training_id
  //   };
  //   AnalysisService.movements(movementsParams).then(function(data){
  //     console.log('movements data : ', data);
  //     $scope.$apply(function() {
  //       vm.attackBtn = data.data[0].name + '<span class="att">' + data.data[0].att + ' / ' + data.data[0].suc + '</span>';
  //       vm.defenseBtn = data.data[1].name + '<span class="att">' + data.data[1].att + ' / ' + data.data[1].suc + '</span>';
  //       vm.leftFootBtn = data.data[2].name + '<span class="att">' + data.data[2].att + ' / ' + data.data[2].suc + '</span>';
  //       vm.rightFootBtn = data.data[3].name + '<span class="att">' + data.data[3].att + ' / ' + data.data[3].suc + '</span>';

  //       _.remove(data.data, function (movement) {
  //         return movement.id === 0;
  //       });
  //       vm.metaData.movements = data.data;
  //     });
  //   });
  // };

  // vm.renderHtml = function(str){
  //   return $sce.trustAsHtml(str);
  // };

  // //화면에 동작정보 세팅
  // vm.setMovementsInfo();

  // //경기장 위치 데이터 조회
  // AnalysisService.getLocationList().then(function(data){
  //   $scope.$apply(function() {
  //     vm.metaData.locations = data.data;
  //   });
  // });

  // // AnalysisService.getLocationList({side:'B'}).then(function(data){
  // //   $scope.$apply(function() {
  // //     console.log('locations : ', data)
  // //     vm.metaData.locations = data.data;
  // //   });
  // // });

  // // 위치 데이터 조회
  // // AnalysisService.locations({
  // //   user_id: 13,
  // //   game_id: 60   // 의미는 없음. 위치목록 조회를 위한 임의의 game_id
  // // }).then(function(data) {
  // //   $scope.$apply(function() {
  // //     // locations 에서 공격,수비 삭제
  // //     _.remove(data.data, function (location) {
  // //       return location.name === '좌측' || location.name === '우측' || location.name === '위' || location.name === '아래' || location.name === '성공' || location.name === '실패';
  // //     });

  // //     vm.metaData.locations = data.data;
  // //   });
  // // });

  // /**
  //  * 동작 기능
  //  */
  // // 버튼 클릭
  // vm.doNext = function($event, step, id, name) {
  //   //경기id체크
  //   // if(!vm.setResultData.user_id){
  //   //   alert('게임을 시작하지 않았습니다.');
  //   //   return;
  //   // }
  //   if(!vm.setResultData.game_id && !vm.setResultData.training_id){
  //     toastr.error('선택하신 일자에 기록된 정보가 없습니다. 먼저 해당일자를 선택하시거나 경기를 시작해주십시오');
  //     return;
  //   }

  //   if (!vm.setResultData.is_defense && step > 1) {
  //     return;
  //   }

  //   if (!vm.setResultData.is_left && step > 2) {
  //     return;
  //   }

  //   if (!vm.setResultData.movement_id && step > 3) {
  //     return;
  //   }

  //   if (!vm.setResultData.location_id && step > 4) {
  //     return;
  //   }

  //   if (!vm.setResultData.loc_code && step > 5) {
  //     return;
  //   }

  //   if(step == '3'){
  //     vm.setStartingPalyers();
  //   }

  //   let li = $($event.currentTarget).parent();
  //   $('.record-container section ul li.step' + step).not(li).removeClass('selected');
  //   $($event.currentTarget).parent().toggleClass('selected');

  //   // 공격/수비
  //   if (step == 1 && vm.setResultData.is_defense == id) {
  //     vm.setResultData.is_defense = null;
  //     vm.movementRecord.skills.movement = null;
  //   } else if (step == 1) {
  //     vm.setResultData.is_defense = id;
  //     vm.movementRecord.skills.movement = name;
  //   }

  //   // 왼발/오른발
  //   if (step == 2 && vm.setResultData.is_left == id) {
  //     vm.setResultData.is_left = null;
  //     vm.movementRecord.skills.foot = null;
  //   } else if (step == 2) {
  //     vm.setResultData.is_left = id;
  //     vm.movementRecord.skills.foot = name;
  //   }

  //   // 동작
  //   if (step == 3 && vm.setResultData.movement_id == id) {
  //     vm.setResultData.movement_id = null;
  //     vm.movementRecord.skills.skill = null;
  //   } else if (step == 3) {
  //     vm.setResultData.movement_id = id;
  //     vm.movementRecord.skills.skill = name;
  //   }

  //   let movement = vm.movementRecord.skills.movement;
  //   let foot = vm.movementRecord.skills.foot;
  //   let skill = vm.movementRecord.skills.skill;

  //   vm.movementRecord.movemnetsText = `(${movement}/${foot}/${skill})`;

  //   // 위치
  //   if (step == 4 && vm.setResultData.location_id == id) {
  //     vm.setResultData.location_id = null;
  //     vm.movementRecord.movemnetsText = `(${movement}/${foot}/${skill})`;
  //     $($event.currentTarget).removeClass('selectLocation');
  //   } else if (step == 4) {
  //     vm.setResultData.location_id = id;
  //     vm.movementRecord.movemnetsText = `(${movement}/${foot}/${skill}) - ${name} - ${id}`;
  //     $('.selectLocation').removeClass('selectLocation');
  //     $($event.currentTarget).addClass('selectLocation');
  //   }

  //   // 추가 위치
  //   // if (step == 5 && vm.setResultData.loc_code == id) {
  //   //   vm.setResultData.loc_code = null;
  //   // } else if (step == 5) {
  //   //   vm.setResultData.loc_code = id;
  //   // }
  // };

  // //동작기록 사용차 추가/삭제 화면 호출
  // vm.movementsUserSet = function(chk) {
  //   $scope.movementsSetting = chk;
  // };

  // //동작기록 사용자 추가
  // vm.addMovements = function() {
  //   // AnalysisService.getLocationList({side:'B'}).then(function(data){
  //   let params = {
  //     login_id: userBasicInfo.login_id,
  //     uuid: userBasicInfo.uuid,
  //     name: vm.addMovement.name
  //   };
  //   console.log(params);
  //   AnalysisService.addMovements(params).then(function(data) {
  //     if(data.result == 'SUC'){
  //       toastr.success('동작정보가 추가 되었습니다.');
  //       vm.setMovementsInfo();
  //     }else{
  //       toastr.error('동작정보 추가중 오류가 발생했습니다.');
  //     }
  //   });
  // }

  // //동작기록 사용자 삭제
  // vm.removeMovements = function() {
  //   let movement_id = vm.removeMovement.id;
  //   let params = {
  //     login_id: userBasicInfo.login_id,
  //     uuid: userBasicInfo.uuid,
  //     movement_id: movement_id
  //   };
  //   console.log(params);
  //   AnalysisService.removeMovements(params).then(function(data) {
  //     if(data.result == 'SUC'){
  //       toastr.success('동작정보가 삭제 되었습니다.');
  //       vm.setMovementsInfo();
  //     }else{
  //       toastr.error('이 동작은 삭제할 수 없습니다.');
  //     }
  //   });
  // }

  // vm.preMovementPage = function() {
  //   vm.setResultData.movement_id = null;
  //   vm.setResultData.location_id = null;
  //   $('.selectLocation').removeClass('selectLocation');
  // };

  // // 초기화
  // vm.clearResultData = function() {
  //   vm.setResultData.is_defense = null;
  //   vm.setResultData.is_left = null;
  //   vm.setResultData.movement_id = null;
  //   vm.setResultData.location_id = null;
  //   vm.setResultData.loc_code = null;
  //   vm.setResultData.is_success = null;
  // };

  // vm.setResult = function(isSuccess) {
  //   if(vm.setResultData.game_id){
  //     vm.setGameMovementResult(isSuccess);
  //   }else if(vm.setResultData.training_id){
  //     vm.setTrainingMovementResult(isSuccess);
  //   }
  // }

  // //동작 결과 입력 (훈련)
  // vm.setTrainingMovementResult = function(isSuccess){
  //   console.log('훈련 동작 기록 저장 !!!');
  //   vm.setResultData.is_success = isSuccess;

  //   console.log('훈련 vm.setResultData : ', vm.setResultData);

  //   if(!vm.setResultData.location_id){
  //     toastr.error('선수 위치를 선택해 주십시오!');
  //     return;
  //   }

  //   if(!vm.setResultData.user_id){
  //     toastr.error('선수를 선택하지 않았습니다.!');
  //     return;
  //   }

  //   // let movementId = vm.setResultData.movement_id;
  //   // let user_id = +(vm.setResultData.user_id);

  //   //개인선수 - 동작기록 저장
  //   AnalysisService.setResult(vm.setResultData).then(function(data) {
  //     console.log('개인동작기록 훈련 저장 완료 : ', data);
  //     $scope.targetPlayer = null;
  //     // $scope.targetOppPlayer = null;
  //     vm.setMovementsInfo();
  //     vm.clearResultData();
  //   });
  // }

  // // 동작 결과 입력 (게임)
  // vm.setGameMovementResult = function(isSuccess) {
  //   vm.setResultData.is_success = isSuccess;
  //   if(!vm.setResultData.location_id){
  //     toastr.error('선수 위치를 선택해 주십시오!');
  //     return;
  //   }

  //   if(!vm.setResultData.user_id){
  //     toastr.error('선수를 선택하지 않았습니다.!');
  //     return;
  //   }

  //   let movementId = vm.setResultData.movement_id;
  //   let user_id = +(vm.setResultData.user_id);
  //   let idx = _.findIndex(
  //     $scope.$parent.base.playerGameResultData.players_game_result.per_user_data,
  //     {
  //       'user_id': vm.setResultData.user_id
  //     }
  //   );

  //   // 동작기록할 때 경기 진행 시간 분,초 기록 - 추후에는 경기 진행시간의 분,초 대신 분,초를 직접 입력할 수 있게 수정해야 함
  //   let progressTime = ($scope.$parent.base.commonData.progressTime) ? ($scope.$parent.base.commonData.progressTime).split(':') : '';
  //   if (progressTime.length) {
  //     let hour = parseInt(progressTime[0], 10);
  //     let minute = parseInt(progressTime[1], 10);
  //     let second = parseInt(progressTime[2], 10);

  //     if (hour) {
  //       minute = minute + hour * 60;
  //     }

  //     vm.setResultData.minute = minute;
  //     vm.setResultData.second = second;
  //   }

  //   //개인선수 - 동작기록 저장
  //   AnalysisService.setResult(vm.setResultData).then(function(data) {
  //     // 득점, 도움, 파울 경기기록에 기록
  //     if (movementId == 36 && isSuccess === 'Y') {
  //       $scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].goals = '' + (+$scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].goals + 1);
  //     } else if (movementId == 37 && isSuccess === 'Y') {
  //       $scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].assists = '' + (+$scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].assists + 1);
  //     } else if (movementId == 38 && isSuccess === 'Y') {
  //       $scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].fouls = '' + (+$scope.$parent.base.playerGameResultData.players_game_result.per_user_data[idx].fouls + 1);
  //     }

  //     //팀전체 동작 기록 저장
  //     vm.setResultData.user_id = null;
  //     AnalysisService.setResult(vm.setResultData).then(function(data) {
  //       // 득점, 도움, 파울 경기기록에 기록
  //       if (movementId == 36 && isSuccess === 'Y') {
  //         $scope.$parent.base.gameResultData.goals = '' + (+$scope.$parent.base.gameResultData.goals + 1);
  //       } else if (movementId == 37 && isSuccess === 'Y') {
  //         $scope.$parent.base.gameResultData.assists = '' + (+$scope.$parent.base.gameResultData.assists + 1);
  //       } else if (movementId == 38 && isSuccess === 'Y') {
  //         $scope.$parent.base.gameResultData.fouls = '' + (+$scope.$parent.base.gameResultData.fouls + 1);
  //       }
  //       $scope.targetPlayer = null;
  //       $scope.targetOppPlayer = null;
  //       vm.setMovementsInfo();
  //       vm.clearResultData();
  //       $scope.$parent.base.setGameResult();
  //     });
  //   });
  // };

  // /**
  //  * 동작정보 입력 타겟 선수 선택 (접속자팀 선수 선택)
  //  */
  // vm.selectTargetPlayer = function(e, user_id, idx) {
  //   if($scope.targetPlayer == idx){
  //     $scope.targetPlayer = null;
  //     vm.setResultData.user_id = null;
  //   }else{
  //     $scope.targetOppPlayer = null;  //상대팀 선수 선택 초기화
  //     $scope.targetPlayer = idx;
  //     vm.setResultData.user_id = user_id;
  //   }
  // }

  // /**
  //  * 동작정보 입력 타켓 선수 선택 (상대팀 선수 선택)
  //  */
  // vm.selectTargetOppPlayer = function(e, user_id, idx) {
  //   if($scope.targetOppPlayer == idx){
  //     $scope.targetOppPlayer = null;
  //     vm.setResultData.user_id = null;
  //   }else{
  //     $scope.targetPlayer = null;  //접속자팀 선수 선택 초기화
  //     $scope.targetOppPlayer = idx;
  //     vm.setResultData.user_id = user_id;
  //   }
  // }

  // //선발선수 조회
  // vm.setStartingPalyers = function() {
  //   console.log('setStartingPalyers exe')
  //   if(vm.setResultData.game_id || vm.setResultData.training_id){
  //     console.log('vm.setResultData : ', vm.setResultData);
  //     //접속자팀 엔트리 목록 조회
  //     let entryParams = {
  //       login_id: userBasicInfo.login_id,
  //       uuid: userBasicInfo.uuid,
  //       game_id: vm.setResultData.game_id,
  //       training_id: vm.setResultData.training_id,
  //       is_oppo: null,
  //       status: 'IN'
  //     };
  //     console.log('entryParams : ', entryParams);
  //     if(!vm.setResultData.training_id){
  //       PlanService.getEntry(entryParams).then(function(data) {
  //         if(data.result == 'SUC'){
  //           console.log('entryParams game', data);
  //           vm.entryPlayers = data.players
  //         }
  //       });
  //     }else{
  //       PlanService.getTrainingEntry(entryParams).then(function(data) {
  //         if(data.result == 'SUC'){
  //           console.log('entryParams training', data);
  //           vm.entryPlayers = data.players
  //         }
  //       });
  //     }

  //     //상대팀 엔트리 목록 조회
  //     if(!vm.setResultData.training_id){
  //       let opoEntryParams = {
  //         login_id: userBasicInfo.login_id,
  //         uuid: userBasicInfo.uuid,
  //         game_id: vm.setResultData.game_id,
  //         is_oppo: 'Y',
  //         status: 'IN'
  //       };
  //       PlanService.getEntry(opoEntryParams).then(function(data) {
  //         if(data.result == 'SUC'){
  //           console.log('opoEntryParams', data);
  //           vm.oppEntryPlayers = data.players
  //         }
  //       });
  //     }
  //   }
  // }

  // // vm.setResultData.movement_id 가 처음 생길 때 div.field 가 나타나서 이벤트 리스너를 등록할 수 있음
  // $scope.$watch('recordMovement.setResultData.movement_id', function(newVal, oldVal) {
  //   /*
  //    * 축구장에서 축구공 근처를 클릭하면 가장 가까운 축구공이 선택되도록 함
  //    */
  //   if (newVal) {
  //     $timeout(function() {
  //       let field = $('div.field');
  //       let balls = field.find('a');
  //       let radius = 15;  // 축구공 반지름

  //       let fieldWidth = field.width();
  //       let fieldHeight = field.height();
  //       let fieldOffset = field.offset();
  //       let bodyZoom = $('body').css('zoom');
  //       field.on('click', function(e) {
  //         // 축구장 클릭 지점을 실제 축구장에서의 위치로 변환
  //         // 축구장 크기는 가로 105m, 세로 65m 로 생각함
  //         // 왼쪽 상단에서 부터의 거리를 계산
  //         // on_run.js 에서 웹브라우저의 크기에 따라 body 에 zoom 으로 확대 축소를 하므로 정확한 계산을 위해서 zoom 값으로 나눠줌
  //         if (typeof e.offsetX !== 'undefined' && typeof e.offsetY !== 'undefined') {
  //           let offsetX;
  //           let offsetY;

  //           // 축구장 클릭
  //           if (e.target.tagName.toLowerCase() === 'div') {
  //             offsetX = e.offsetX;
  //             offsetY = e.offsetY;
  //           }
  //           // 축구공 클릭
  //           else if (e.target.tagName.toLowerCase() === 'a') {
  //             let ballOffset = $(e.target).offset();

  //             offsetX = ballOffset.left - fieldOffset.left + e.offsetX;
  //             offsetY = ballOffset.top - fieldOffset.top + e.offsetY;
  //           }

  //           let positionX = parseInt(offsetX * 105 / fieldWidth / bodyZoom, 10);
  //           let positionY = parseInt(offsetY * 65 / fieldHeight / bodyZoom, 10);

  //           console.log(positionX, positionY);
  //         }

  //         if (e.target.tagName.toLowerCase() === 'div') {   // 축구공 (a 태그) 를 클릭한 경우는 제외함
  //           let gaps = [];

  //           balls.each(function() {
  //             let ball = $(this);
  //             let offset = ball.offset();

  //             gaps.push({
  //               ball: ball,
  //               gap: Math.sqrt(Math.abs(offset.top + radius - e.clientY) * Math.abs(offset.top + radius - e.clientY) + Math.abs(offset.left + radius - e.clientX) * Math.abs(offset.left + radius - e.clientX))
  //             });
  //           });

  //           gaps = _.sortBy(gaps, 'gap');
  //           gaps[0].ball.click();   // 가장 가까운 축구공 클릭
  //         }
  //       });
  //     }, 0);
  //   }
  // });
}

export default {
  name: 'RecordMovementCtrl',
  fn: RecordMovementCtrl
};
